var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ads-type-21 cursor-pointer",on:{"click":function($event){$event.preventDefault();return _vm.onAdsClick($event)}}},[_c(_vm.pageLayout,{tag:"component",attrs:{"material":_vm.materials[0]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }